import { formatDate } from '../../../helpers/date'

/*
* @TODO remove this interface once this function is only used with the 'Track' interface
* */
interface TrackLike {
    owner: { id: string };
    shift?: {
        period?: {
            start?: string | Date;
            end?: string | Date;
        };
        start?: string | Date;
        end?: string | Date;
        shiftPlannings?: {
            customStartTime?: boolean;
            user?: { id: string };
            period?: {
                start: string | Date;
                end: string | Date;
            };
            start?: string | Date;
            end?: string | Date;
        }[];
    } | undefined;
}

export const getShiftStartAndEndTimeOfTrack = (track: TrackLike): string => {
    if (! track.shift) {
        return ''
    }

    const customShiftPlanning = (track.shift.shiftPlannings || []).find(
        shiftPlanning => shiftPlanning.customStartTime && shiftPlanning.user?.id === track.owner.id,
    )
    const startDate = customShiftPlanning
        ? formatDate(customShiftPlanning.period?.start || customShiftPlanning.start || '', 'HH:mm')
        : formatDate(track.shift.period?.start || track.shift.start || '', 'HH:mm')
    const endDate = customShiftPlanning
        ? formatDate(customShiftPlanning.period?.end || customShiftPlanning.end || '', 'HH:mm')
        : formatDate(track.shift.period?.end || track.shift.end || '', 'HH:mm')

    return `${startDate} - ${endDate}`
}
